export default function metricesDataSelector(func) {
  return func((state) => state.metricesReducer);
}
